import styled from 'styled-components'

interface CheckBoxIconStyle {
  customBorderColor: string
}

export const CheckBoxContainer = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
`

export const CheckBoxIcon = styled.div<CheckBoxIconStyle>`
  align-items: center;
  display: flex;
  margin-right: 5px;

  > svg {
    fill: ${props => props.customBorderColor ? props.customBorderColor : '#1f35b5'};
  }
`

export const CheckBoxText = styled.div`
  p {
    color: ${props => props['aria-disabled'] ? '#c4c4c4' : 'initial'}
  }
`